import { useState } from "react";
import { toast } from "sonner";
import { STATUS_LABELS } from "@/data";
import { adminApi, errorText, formatDate, money } from "./api";

const STATUSES = Object.keys(STATUS_LABELS);

export default function AdminOrders({ orders, onChanged }) {
  const [filter, setFilter] = useState("");
  const shown = filter ? orders.filter((o) => o.status === filter) : orders;

  const setStatus = async (id, status) => {
    try { await adminApi.patch(`/orders/${id}`, { status }); toast.success(`Commande ${id} → ${STATUS_LABELS[status]}`); onChanged(); }
    catch (e) { toast.error(errorText(e, "Mise à jour impossible")); }
  };

  return (
    <section className="vf-admin-block" data-testid="admin-orders">
      <header>
        <div><p className="vf-kicker">Commandes</p><h2>Les dernières <em>commandes</em></h2></div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="orders-filter-select">
          <option value="">Toutes ({orders.length})</option>
          {STATUSES.map((s) => <option key={s} value={s}>{STATUS_LABELS[s]} ({orders.filter((o) => o.status === s).length})</option>)}
        </select>
      </header>
      {shown.length === 0 && <p className="vf-admin-muted" data-testid="orders-empty">Aucune commande dans cette catégorie.</p>}
      <div className="vf-admin-table">
        {shown.map((o) => (
          <article className="vf-admin-row" key={o.id} data-testid={`order-row-${o.id}`}>
            <div className="c-id"><b>{o.id}</b><span>{formatDate(o.created_at)}</span></div>
            <div className="c-client"><b>{o.customer_name}</b><span>{o.email}{o.phone ? ` · ${o.phone}` : ""}</span><span>{o.address}, {o.postal_code} {o.city}</span></div>
            <div className="c-items">{(o.items || []).map((i) => <span key={i.variant_id}>{i.variant_name} <i>× {i.quantity}</i></span>)}</div>
            <div className="c-total"><b>{money(o.total)}</b><span>{o.payment_method === "card" ? "Carte" : "Sur demande"}</span></div>
            <div className="c-status">
              <select className={`s-${o.status}`} value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} data-testid={`order-status-select-${o.id}`}>
                {STATUSES.map((s) => <option key={s} value={s}>{STATUS_LABELS[s]}</option>)}
              </select>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
